<div class="price-cell-editor">
  <input [(ngModel)]="value" (ngModelChange)="onValueChanged($event)" class="price-input" />
  <app-display-icon
    (click)="onCustomButtonClick()"
    [border]="false"
    [colour]="iconColourEnum.primary"
    [icon]="icons.backSpaceOutline">
  </app-display-icon>
</div>
